import { AxiosResponse } from "axios";
import { IPartyCorrelation } from "../features/partiesinvolved/logic/PartiesInvolvedSlice";
import { axiosInstance, MessageResponse } from "./common";

export const PARTY_TYPE_OPTIONS = {
  BORROWER: "BORROWER",
  EMPLOYEE: "EMPLOYEE",
  FORMER_EMPLOYEE: "FORMER_EMPLOYEE",
  SOURCING_PARTNER: "SOURCING_PARTNER",
  SELLER: "SELLER",
  VENDOR: "VENDOR",
  OTHER: "OTHER",
};

export const PARTY_TYPE_LABELS = {
  [PARTY_TYPE_OPTIONS.BORROWER]: "Borrower",
  [PARTY_TYPE_OPTIONS.EMPLOYEE]: "Employee",
  [PARTY_TYPE_OPTIONS.FORMER_EMPLOYEE]: "Former Employee",
  [PARTY_TYPE_OPTIONS.SOURCING_PARTNER]: "Sourcing Partner",
  [PARTY_TYPE_OPTIONS.SELLER]: "Seller",
  [PARTY_TYPE_OPTIONS.VENDOR]: "Vendor",
  [PARTY_TYPE_OPTIONS.OTHER]: "Other",
};

export interface PartyInvolved {
  party_id: string;
  party_type?: string;
  name: string;
  recommended_actions?: string[];
  recommended_action_approver?: string;
  recommended_action_implementation_date?: string;
  recommendation_comment?: string;
  is_fraud?: boolean;
  generate_ro?: boolean;
  implementation_owner?: string;
  closure_note?: string;
  correlation?: IPartyCorrelation;
}

export interface AddPartiesInvolvedRequest {
  parties_involved: PartyInvolved[];
}

export interface UpdatePartyInvolvedRequest {
  party_type?: string;
  name?: string;
  recommended_actions?: string[];
  recommended_action_approver?: string;
  recommended_action_implementation_date?: string;
  recommendation_comment?: string;
  is_fraud?: boolean;
  generate_ro?: boolean;
  implementation_owner?: string;
  closure_note?: string;
  correlation?: IPartyCorrelation;
}

export interface UpsertPartyInvolvedRequest {
  party_id: string;
  party_type?: string | null;
  name?: string | null;
  recommended_actions?: string[];
  recommended_action_approver?: string | null;
  recommended_action_implementation_date?: string | null;
  recommendation_comment?: string;
  is_fraud?: boolean;
  generate_ro?: boolean;
  implementation_owner?: string | null;
  closure_note?: string | null;
  correlation?: IPartyCorrelation;
}

export interface UpsertPartiesInvolvedRequest {
  parties_involved: UpsertPartyInvolvedRequest[];
}

export interface PartiesInvolvedResponse {
  parties_involved: PartyInvolved[];
}

const PartiesInvolvedActionsAPI = {
  add: async (
    case_id: string,
    request: AddPartiesInvolvedRequest
  ): Promise<MessageResponse> => {
    const response: AxiosResponse<MessageResponse> = await axiosInstance.post(
      `v1/cases/${case_id}/parties-involved`,
      request
    );
    return response.data;
  },

  update: async (
    case_id: string,
    party_id: string,
    request: UpdatePartyInvolvedRequest
  ): Promise<MessageResponse> => {
    const response: AxiosResponse<MessageResponse> = await axiosInstance.patch(
      `v1/cases/${case_id}/parties-involved/${party_id}`,
      request
    );
    return response.data;
  },

  upsert: async (
    case_id: string,
    request: UpsertPartiesInvolvedRequest
  ): Promise<MessageResponse> => {
    const response: AxiosResponse<MessageResponse> = await axiosInstance.put(
      `v1/cases/${case_id}/parties-involved`,
      request
    );
    return response.data;
  },

  delete: async (
    case_id: string,
    party_id: string
  ): Promise<MessageResponse> => {
    const response: AxiosResponse<MessageResponse> = await axiosInstance.delete(
      `v1/cases/${case_id}/parties-involved/${party_id}`
    );
    return response.data;
  },
};

export default PartiesInvolvedActionsAPI;
